/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Accordion } from 'react-bootstrap';
import { connect } from 'react-redux';
import { unlinkUploadImage } from '../../store/SupplierSuggestion.action';
import CareInstructionTable from './CareInstructionTable/CareInstructionTable';
import { useSuggestionProvider } from '../../Provider/SuggestionProvider';

function CareLabelsForm({ sectionPermission, selectedType, careTabs, setCareTabs, productRef, unlinkUploadImage, productRefBlank }) {
  const [uploadedImg, setUploadedImg] = useState([]);
  const [comState, setComState] = useState({
    accodionArray: [],
  });
  const { userState, setUserState } = useSuggestionProvider();

  const componentCleanup = async () => {
    if (uploadedImg.length > 0) {
      const res = await unlinkUploadImage({ images: uploadedImg });
      if (res) {
        setUploadedImg([]);
      }
    }
  };

  useEffect(() => {
    const handleBeforeUnload = () => {
      componentCleanup().catch(console.error);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const savedUploadedImage = async (val) => {
    setUploadedImg([...uploadedImg, val.image, val.fullImage]);
  };
  const delateUploadedImage = async (val) => {
    const newArray = uploadedImg.filter((item) => !val.includes(item));
    setUploadedImg(newArray);
  };
  const handleClickToggle = (eventKey) => {
    const copyaccodionArray = comState.accodionArray;
    const accIndex = copyaccodionArray.indexOf(eventKey);
    if (accIndex >= 0) {
      copyaccodionArray.splice(accIndex, 1);
    } else copyaccodionArray.push(eventKey);
    setComState((prevState) => ({
      ...prevState,
      accodionArray: copyaccodionArray,
    }));
  };

  const checkAccodionActiveState = (str) => comState.accodionArray.includes(str);

  return (
    <div className="supplier-add container-fluid">
      <div className="collapse-card ">
        {careTabs.map((ele) => {
          return (
            <Accordion className="common-accordion" key={ele} activeKey={checkAccodionActiveState(ele?.tabName)}>
              {sectionPermission?.isVisibleToSupplier?.[ele?.tabId] && (
                <CareInstructionTable
                  selectedType={selectedType}
                  delateUploadedImage={delateUploadedImage}
                  savedUploadedImage={savedUploadedImage}
                  checkAccodionActiveState={checkAccodionActiveState}
                  handleClickToggle={handleClickToggle}
                  productRefBlank={productRefBlank}
                  ele={ele}
                  productRef={productRef}
                  userState={userState}
                  setUserState={setUserState}
                  careTabs={careTabs}
                  setCareTabs={setCareTabs}
                  comState={comState}
                />
              )}
            </Accordion>
          );
        })}
      </div>
    </div>
  );
}
const mapStateToProps = ({ UserDetails }) => {
  const { userInfo } = UserDetails;
  return {
    userInfo,
  };
};

const mapStateToDispatch = { unlinkUploadImage };

export default connect(mapStateToProps, mapStateToDispatch)(CareLabelsForm);
